/**
 * Created by sskolla on 10/1/2018.
 */
export interface Phone {
  communicationId: number;
  phoneNumber: number;
  phoneExtension: string;
  intlDialCode: number;
  countryAreaCd: number;
  prefCode: string;
  prefCatCode: string;
  phoneNumberType: string;
  isoTwoCharCntryCode?: string;

}
